if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.scrollTimer = null;
      }

      connectedCallback() {
        if (this.dataset.sliderReady) return;
        this.dataset.sliderReady = true;

        this.prevBtn = this.querySelector('.product-media-modal__arrow--prev');
        this.nextBtn = this.querySelector('.product-media-modal__arrow--next');
        this.container = this.querySelector('[role="document"]');

        [this.prevBtn, this.nextBtn].forEach((button) => {
          if (!button) return;

          ['click', 'pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach((eventName) => {
            button.addEventListener(eventName, (event) => {
              event.preventDefault();
              event.stopPropagation();
            });
          });
        });

        this.prevBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.slideMedia(-1);
        });

        this.nextBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.slideMedia(1);
        });

        this.container?.addEventListener(
          'scroll',
          () => {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
              this.setActiveMediaFromScroll();
            }, 80);
          },
          { passive: true }
        );

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.slideMedia(-1);
          if (event.key === 'ArrowRight') this.slideMedia(1);
        });
      }

      show(opener) {
        this.classList.add('is-preparing');

        super.show(opener);

        this.classList.remove('is-closing');
        this.classList.add('is-opening');

        this.showActiveMedia(false);

        requestAnimationFrame(() => {
          this.classList.remove('is-preparing');

          setTimeout(() => {
            this.classList.remove('is-opening');
          }, 250);
        });
      }

      hide() {
        if (!this.hasAttribute('open')) return;

        this.classList.add('is-closing');

        setTimeout(() => {
          this.classList.remove('is-closing');
          super.hide();
        }, 220);
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      showActiveMedia(smooth = true) {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.setActiveMedia(activeMedia, smooth);
      }

      setActiveMedia(activeMedia, smooth = true) {
        const mediaItems = this.getMediaItems();
        const container = this.container || this.querySelector('[role="document"]');

        mediaItems.forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const slide = activeMedia.closest('.product-media-modal__slide') || activeMedia;

        if (container && slide) {
          if (!smooth) {
            const oldScrollBehavior = container.style.scrollBehavior;

            container.style.scrollBehavior = 'auto';

            container.scrollLeft = slide.offsetLeft;

            requestAnimationFrame(() => {
              container.style.scrollBehavior = oldScrollBehavior;
            });
          } else {
            slide.scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest',
            });
          }
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      slideMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        let activeIndex = mediaItems.findIndex((item) => item.classList.contains('active'));

        if (activeIndex === -1) {
          activeIndex = 0;
        }

        let nextIndex = activeIndex + direction;

        if (nextIndex < 0) {
          nextIndex = mediaItems.length - 1;
        }

        if (nextIndex >= mediaItems.length) {
          nextIndex = 0;
        }

        this.setActiveMedia(mediaItems[nextIndex], true);
      }

      setActiveMediaFromScroll() {
        const container = this.container;
        const mediaItems = this.getMediaItems();

        if (!container || !mediaItems.length) return;

        const containerCenter = container.scrollLeft + container.clientWidth / 2;

        let closestMedia = mediaItems[0];
        let closestDistance = Infinity;

        mediaItems.forEach((media) => {
          const slide = media.closest('.product-media-modal__slide') || media;
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(containerCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestMedia = media;
          }
        });

        mediaItems.forEach((element) => {
          element.classList.toggle('active', element === closestMedia);
        });
      }
    }
  );
}